import { render, staticRenderFns } from "./ActiveSessionPage.vue?vue&type=template&id=3a65db8a&scoped=true"
import script from "./ActiveSessionPage.vue?vue&type=script&lang=js"
export * from "./ActiveSessionPage.vue?vue&type=script&lang=js"
import style0 from "./ActiveSessionPage.vue?vue&type=style&index=0&id=3a65db8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65db8a",
  null
  
)

export default component.exports